/**
 * v4 sign-in: the same Google identity and domain rule as the current Hub
 * (GoogleAuthContext), drawn with the design system. UI gate only; the API verifies
 * the token on every request.
 */
import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { appConfig } from '@/utils/config';
import { useGoogleAuth } from '@/auth/GoogleAuthContext';
import { Card } from '@/ds';

export function V4LoginGate({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, acceptCredential } = useGoogleAuth();
  const [error, setError] = useState<string | null>(null);
  const domain = appConfig.allowedGoogleDomain;
  if (isAuthenticated) return <>{children}</>;
  return (
    <div className="v4-login">
      <div className="v4-login-card">
        <Card label="DelRicht Recruitment Hub" padded>
          <h1 className="ds-h2">Sign in to continue</h1>
          <p className="ds-muted">Use your <strong>@{domain}</strong> Google account.</p>
          {appConfig.googleClientId ? (
            <GoogleLogin
              onSuccess={(cred) => {
                setError(null);
                const err = cred.credential ? acceptCredential(cred.credential)
                  : 'Google returned no sign-in. Please try again.';
                if (err) setError(err);
              }}
              onError={() => setError('Google sign-in failed. Please try again.')}
              hosted_domain={domain} shape="pill" text="signin_with" />
          ) : (
            <p className="ds-state ds-state--failed">
              Sign-in is not configured (VITE_GOOGLE_CLIENT_ID is missing). Contact an administrator.
            </p>
          )}
          {error ? <p role="alert" className="ds-state ds-state--failed">{error}</p> : null}
          <p className="ds-small ds-muted" style={{ marginBottom: 0 }}>Access is limited to authorized DelRicht staff.</p>
        </Card>
      </div>
    </div>
  );
}
